// extracted by mini-css-extract-plugin
export default {"conversationCard":"style_conversationCard__Ac9r+","activate":"style_activate__Nb8wO","iconChat":"style_iconChat__cqrAf"};